import { useParams } from "react-router-dom"
import { Section, SectionRoot } from "@hydrologiq/shared/chakra/custom/Section"
import { VStack } from "@chakra-ui/react"
import ForecastSummary from "@hydrologiq/shared/forecast/ForecastSummary"
import ForecastChart from "@hydrologiq/shared/forecast/ForecastChart"
import { ForecastProvider } from "@hydrologiq/shared/forecast/ForecastProvider"
import { useAsset } from "../hooks/useAsset"
import { toUserTZ } from "@hydrologiq/common/helpers/date"

export default function AssetForecast() {
  const { assetId = "" } = useParams()
  // Get asset monitoring
  const { asset } = useAsset(assetId)
  const latestAssignment = asset?.assignments?.all?.find((assignment) => assignment.id === asset?.assignments?.latest)
  const end = latestAssignment?.end ? toUserTZ(latestAssignment?.end) : undefined

  return (
    <SectionRoot>
      <Section separator={false} loading={!asset}>
        <ForecastProvider entityType="asset" assetId={assetId}>
          <VStack align="stretch" gap={6}>
            <ForecastSummary entityType="asset" assetId={assetId} start={end} />
            <ForecastChart entityType="asset" assetId={assetId} />
          </VStack>
        </ForecastProvider>
      </Section>
    </SectionRoot>
  )
}
